<template>
  <ul class="vuejs-countdown">
    <li v-if="days > 0">
      <p class="digit">{{ days | twoDigits }}</p>
    </li>
    <li>
      <p class="digit">{{ hours | twoDigits }}</p>
    </li>
    <li>
      <p class="digit">{{ minutes | twoDigits }}</p>
    </li>
    <li>
      <p class="digit">{{ seconds | twoDigits }}</p>
    </li>
  </ul>
</template>

<script>
let interval = null;
export default {
  name: 'vuejsCountDown',
  props: {
    deadline: {
      type: Number
    },
    end: {
      type: String
    },
    stop: {
      type: Boolean
    }
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: null,
      diff: 0
    }
  },
  created() {
    if (!this.deadline && !this.end) {
      throw new Error("Missing props 'deadline' or 'end'");
    }
    let endTime = this.deadline ? this.deadline : this.end;
    this.date = this.deadline;
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline' or 'end'");
    }
    interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000);


    }, 1000);
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60
    },
    minutes() {
      return Math.trunc(this.diff / 60) % 60
    },
    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24)
    }
  },
  watch: {
    now(value) {
      this.diff = this.date - this.now;
      if(this.diff <= 0 || this.stop){
        this.diff = 0;
        // Remove interval
        clearInterval(interval);

        this.$emit("timeIsUp", true)
      }
    }
  },
  filters: {
    twoDigits(value) {
      if ( value.toString().length <= 1 ) {
        return '0'+value.toString()
      }
      return value.toString()
    }
  },
  destroyed() {
    clearInterval(interval);
  }
}
</script>
<style>
.vuejs-countdown {
  padding: 0;
  margin: 0 !important;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  list-style: none;
}
.vuejs-countdown li {
  display: inline-flex;
  align-items: center;
  margin: 0;
  text-align: center;
  position: relative;
  background: none;
  padding: 0;
  border-radius: 0;
}
.vuejs-countdown li p {
  margin: 0;
  padding: 0;
}
.vuejs-countdown li:after {
  content: ":";
  position: relative;
  right: auto;
  top: auto;
  margin-left: 6px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: #ae71ff;
}
.vuejs-countdown li:first-of-type {
  margin-left: 0;
}
.vuejs-countdown li:last-of-type {
  margin-right: 0;
}
.vuejs-countdown li:last-of-type:after {
  content: "";
  margin-left: 0;
}
.vuejs-countdown .digit {
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  margin: 0;
  padding: 0;
  color: #ae71ff;
  font-variant-numeric: tabular-nums;
}
.vuejs-countdown .text {
  text-transform: uppercase;
  margin-bottom: 0;
  font-size: 12px;
}

@media (max-width: 767px) {
  .vuejs-countdown .digit {
    font-size: 14px;
  }

  .vuejs-countdown li:after {
    font-size: 14px;
    margin-left: 3px;
  }
}
</style>
